var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23689 11.2615C7.32343 15.3578 10.6564 18.6867 14.7563 20.7708L17.9352 17.5854C18.3339 17.1868 18.9021 17.0731 19.4018 17.232C21.016 17.7657 22.7574 18.0554 24.5554 18.0554C25.3568 18.0554 26 18.6986 26 19.5V24.5554C26 25.3568 25.3568 26 24.5554 26C10.9914 26 0 15.0092 0 1.44458C0 0.647323 0.647323 0 1.44458 0H6.5C7.30142 0 7.94458 0.643158 7.94458 1.44458C7.94458 3.24256 8.23432 4.98462 8.76801 6.60114C8.92686 7.09794 8.81323 7.6703 8.4146 8.06892L5.23689 11.2621V11.2615Z",
    fill: "#124729"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/Contact.c9e178d6a3f0f9b0cd978b1f32341a72.svg";
export { ForwardRef as ReactComponent };